export enum MessagingTemplateDetailsTabTypes {
    GENERAL_INFO = "generalInfo",
    CONTENT = "content"
}